/**
 * The toast element's class.
 */
export const BASE_CLASS = 'base-toast';

/**
 * The individual toast's margin from the edges of the screen, in pixels.
 */
export const GUTTER = 12;
